export const SIMPLE_PAGINATION = {
  current_page: 1,
  next_page: null,
  per_page: 20,
  prev_page: null,
};
